module.exports = __webpack_public_path__ + "static/media/home4.28e397fd.png";